import { render, staticRenderFns } from "./BiocharPartner.vue?vue&type=template&id=deb87682&"
import script from "./BiocharPartner.vue?vue&type=script&lang=js&"
export * from "./BiocharPartner.vue?vue&type=script&lang=js&"
import style0 from "./BiocharPartner.vue?vue&type=style&index=0&id=deb87682&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports